import React from 'react';

interface StarFilledProps {
  color?: string;
  className?: string;
}

export const StarFilled: React.FC<StarFilledProps> = ({ color = 'rgb(var(--color-primary))', className = '' }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.72064 1.00091C7.30214 -0.333638 9.19499 -0.333633 9.77649 1.00091L11.2368 4.35235L14.9553 4.63691C16.4548 4.75166 17.0473 6.63701 15.8831 7.58897L13.1083 9.85788L13.9659 13.29C14.3234 14.7207 12.7835 15.8766 11.5095 15.1339L8.24856 13.2326L4.98761 15.1339C3.71365 15.8766 2.17368 14.7207 2.53121 13.29L3.38887 9.85788L0.614025 7.58897C-0.550205 6.63702 0.0423566 4.75166 1.54185 4.63691L5.26032 4.35235L6.72064 1.00091Z"
        fill={color}
      />
    </svg>
  );
};
